import type { UiStrings } from '../types'

const ru: UiStrings = {
  brand: 'Holecard EX',
  docTitleSuffix: 'Запись процесса',
  tagline: 'Запишите место · карманные · борд · линию — карточка процесса',
  metaDescription:
    'Holecard EX — мобильная запись покерного процесса. Запишите место, карманные карты, борд и действия по улицам в карточку для шеринга.',
  stepsAria: 'Шаги',
  prev: 'Назад',
  undo: 'Отменить',
  next: 'Далее',
  nextSummary: 'К резюме',
  privacyLink: 'Конфиденциальность и реклама',
  privacyTitle: 'Конфиденциальность и реклама',
  privacyHint: 'Черновик для проверки AdSense. Проверьте и обновите перед продакшеном.',
  privacyBack: 'Назад в приложение',
  privacyCollectTitle: '1. Какие данные мы собираем',
  privacyCollectBody:
    'Сейчас Holecard EX собирает черновики разбора только в браузере. Вход не нужен, данные раздачи на сервер не отправляются. Черновики могут временно храниться в sessionStorage этой вкладки (политика обновится при изменениях).',
  privacyAdsTitle: '2. Cookies и реклама',
  privacyAdsBody:
    'Могут использоваться сторонние рекламные сети вроде Google AdSense. Рекламодатели могут использовать cookies или идентификаторы устройств для интересно-ориентированной рекламы. Персонализированную рекламу можно отключить в браузере или настройках Google Ads.',
  privacyContactTitle: '3. Контакты',
  privacyContactBody: 'По вопросам политики откройте issue GitHub holdcard-ex.com. Email оператора: TODO_OPERATOR_EMAIL в конфиге проекта.',
  langAria: 'Язык',
  langCompactAria: 'Язык (кратко)',
  koPathLink: '한국어',
  koPathLinkAria: 'Корейская версия (/ko)',
  enPathLink: 'English',
  enPathLinkAria: 'Английская версия (/)',
  setupTitle: 'Стол',
  setupHint: 'Игроки · стек · блайнды — затем Место → Рука → Линия',
  players: 'Игроки',
  playersUnit: (n) => `${n}-max`,
  sb: 'SB',
  bb: 'BB',
  ante: 'Анте (необяз.)',
  anteHint: 'Та же единица, что у блайндов',
  effectiveStack: 'Эффективный стек (BB, необяз.)',
  potBb: 'Банк (BB, необяз.)',
  metaOptionalHint: 'Оставьте анте / eff / банк пустыми, чтобы скрыть их в резюме',
  setupDetailsToggle: 'Игроки · анте · эфф · банк · фишки',
  setupBasicsHint: 'По умолчанию (6-max · 100bb) ок — Далее или вперёд',
  setupMetaSetChip: 'Анте · eff · банк заданы',
  stackUnit: 'Единица стека',
  stackUnitBb: 'BB',
  stackUnitChips: 'Фишки',
  stackChips: 'Стек (фишки)',
  stackBb: 'Стек (BB)',
  stackChipsUnit: 'фишек',
  positionTitle: 'Место',
  seatQuestion: 'Где вы сидели?',
  settingsBack: 'Назад',
  settingsSegAria: 'Настройки стола (игроки · блайнды · стек)',
  lineSeatEditAria: 'Изменить место',
  lineHoleEditAria: 'Изменить карты',
  positionHint: (count, hint) => `${count}-max места${hint ? ` · ${hint}` : ''}`,
  tableVizAria: (n) => `Места за столом ${n}-max`,
  tableVizHeroBadge: 'вы',
  tableVizHeroSeatAria: (seat) => `${seat} (вы)`,
  tableVizDealer: 'D',
  tableVizDealerTitle: 'Баттон дилера',
  tableVizTapHint: 'Нажмите своё место за столом',
  tableVizListFallback: 'Список мест · коды',
  tableVizBlindsAria: (v) => `Блайнды ${v}`,
  tableVizPotPlaceholder: 'Банк',
  tableVizPotValue: (v) => `Банк ${v}`,
  tableVizPotAria: (v) => `Банк ${v}`,
  tableVizStackAria: (v) => `Стек ${v}`,
  tableVizEmptyMark: '—',
  tableVizEffHint: (v) => `Эфф ${v}bb`,
  tableVizEffTitle: 'Эффективный стек (на весь стол, не по местам)',
  tableVizStepDown: 'Меньше',
  tableVizStepUp: 'Больше',
  tableVizEditDone: 'Готово',
  tableVizInfoHint: 'Нажмите блайнды, банк или стек на столе, чтобы изменить',
  seatAbbrevHint: 'Сокращения мест. Нажмите для полного имени.',

  cardsTitle: 'Рука',
  cardsHint: 'Начните со своих карт · оппоненты через «Добавить оппонентов» · слот · масть и ранг · без дублей',
  heroHolesGuide: (seat) => `Выберите 2 карманные карты ${seat}.`,
  cardSlot1: 'Карта 1',
  cardSlot2: 'Карта 2',
  cardSlotSelect: 'Выбрать',
  seatsLabel: 'Места',
  knownHolesOptional: 'Карманные карты оппонентов необязательны (шоуdown / разбор — можно пусто)',
  holesBySeat: 'Карманные · выберите место',
  seatVillain: (pos) => `Villain ${pos}`,
  seatFilled: 'Задано',
  holesModeHeroOnly: 'Только мои',
  holesModeWithVillains: 'Добавить оппонентов',
  holesModeAria: 'Режим ввода карманных карт',
  villainNudgeToast: 'Знаете руку оппонента? Нажмите BB / CO и т.д.',
  heroCardsDoneCta: 'К линии',
  heroCardsAddVillainsCta: 'Добавить оппонентов',
  suitPickerLabel: 'Масть',
  rankPickerLabel: 'Ранг',
  boardTitle: 'Борд',
  boardHint: 'Когда дойдёте — пропустите для только префлопа',
  flop: 'Флоп',
  turn: 'Тёрн',
  river: 'Ривер',
  flopSlot: (i) => `F${i}`,
  actionsTitle: 'Линия',
  actionsHint: 'Линия действий по улицам — фолд / чек / колл / бет / рейз / олл-ин',
  actorQuick: 'Быстрый актор',
  actor: 'Актор',
  actorPlaceholder: 'Введите имя',
  actorCustomToggle: 'Своё имя',
  actorRequired: 'Введите или выберите актора',
  action: 'Действие',
  sizeLabel: 'Сайз',
  sizePlaceholder: 'напр. 2.5bb',
  sizeRequired: 'Введите сайз для бет/рейз',
  sizeCustomToggle: 'Свой',
  sizeOpenApprox: 'Опен',
  sizePotApprox: 'Размер банка',
  sizeOverbetApprox: 'Овербет',
  sizeJamApprox: 'Шорт / джем',
  sizeUnitBb: 'bb',
  sizeUnitPct: 'pot',
  snapHint: 'Привязка к стопам · ± один шаг',
  favoritesLabel: 'Избранное',
  morePresets: 'Ещё пресеты',
  presetsSizeLabel: 'Пресеты · размер',
  potSizeHintUnset: 'Задайте банк (BB) в сетапе, чтобы видеть размер в bb',
  clearOptional: 'Очистить',
  betRaiseHint: 'Бет: нет предыдущей агрессии · Рейз: против бета/рейза',
  allinSizeHint: 'Опциональный сайз олл-ина',
  sizeActionHint: (potBit) => potBit ? `Бет=первый · Рейз=против бета · ${potBit}` : 'Бет=первый · Рейз=против бета',
  addAction: (street) => `Добавить действие ${street}`,
  updateAction: 'Обновить',
  editAction: 'Править',
  cancelEdit: 'Отмена',
  noStreetActions: (street) => `Пока нет действий на ${street}.`,
  delete: 'Удалить',
  moveUp: 'Вверх',
  moveDown: 'Вниз',
  allActionsHint: (n) => `Всего ${n} действий · смотрите другие вкладки`,
  heroChip: (pos) => pos,
  seatOrderHu: 'HU: BTN играет как SB · порядок BTN/SB → BB',
  seatOrder: (order) => `Порядок мест: ${order}`,
  positionHintHuBtn: 'HU баттон (SB)',
  keepActorHint: 'Вкладки улиц сохраняют актора (сбрасываются только тип/сайз)',
  potQuickPrompt: 'Быстрый банк (BB) — нажмите, чтобы задать и обновить подсказку',
  potQuickClear: 'Очистить банк',
  quickLinesLabel: 'Быстрые линии',
  quickLinesHint: 'Частые шаблоны — нажмите, чтобы добавить',
  macroOpenThenCall: 'Опен затем колл',
  macroFoldToHero: (seat) => `Фолды до ${seat}`,
  macroCbet33: 'C-bet ⅓ pot',
  quickLinesSwitchStreet: 'Смените улицу для макросов',
  macroOpenExists: 'Опен (рейз) уже записан',
  macroAlreadyLogged: 'Опен и колл уже записаны',
  macroFoldToHeroNone: (seat) => `Ранних фолдов нет (или ${seat} ходит первым)`,
  macroFoldToHeroBlocked: 'Раннее действие уже есть — добавьте фолды вручную',
  boardCtaFlop: 'Добавить флоп',
  boardCtaTurn: 'Добавить тёрн',
  boardCtaRiver: 'Добавить ривер',
  quickHand: 'Быстрая раздача',
  skipToCards: 'К картам',
  jumpToActions: 'К линии',
  skipBoardPreflop: 'Пропустить борд — только префлоп',
  boardSlotsToggle: 'Добавить борд',
  softStackAria: 'Рука пока',
  softStackLine: 'Линия',
  softStackHoles: 'Дыры',
  softStackBoard: 'Борд',
  streetTabWithCount: (street, n) => `${street} · ${n}`,
  actionIndexLabel: (n, street) => `Действие ${n} · ${street}`,
  copyLinkTitle: 'Снова открывает эту раздачу в приложении',
  suitStickyHint: 'Масть зафиксирована · нажмите масть, чтобы сменить',
  suitStickyChip: (s) => `Текущая масть ${s}`,
  suitMruLabel: 'Недавние',
  summaryHint: 'Сделайте скриншот карточки процесса ниже или скопируйте/поделитесь текстом',
  summaryHole: 'Карманные',
  summaryBoard: 'Борд',
  summaryActions: 'Действия',
  timelineProcess: 'Процесс',
  timelineBoard: (cards) => `Борд ${cards}`,
  processMoreSummary: 'Больше процесса',
  linePeekSummary: 'Линия до сих пор',
  takeawayLabel: 'Вывод',
  takeawayPlaceholder: 'Только позиция и линия — напр. BTN raise, BB call, flop check',
  takeawayHint: 'Одна строка процесса — только место + линия',
  takeawayNudge: 'Строка процесса (необяз.)\u00a0· место\u00a0· линия',
  takeawayInLinkFact: 'Строка процесса есть в ссылке',
  shareSecondarySummary: 'Заметка · оппоненты (необяз.)',
  shareSecondaryInvite: 'Оставить строку процесса (необяз.)',
  shareMoreSummary: 'Другие способы поделиться',
  lineDraftSummary: 'Актор · сайз',
  explainModeLabel: 'Пояснения',
  explainModeAria: 'Режим пояснений — показать подсказки',
  reviewScopeLabel: 'Обзор до',
  reviewScopePreflop: 'Префлоп',
  reviewScopeFlop: 'Флоп',
  reviewScopeRiver: 'Ривер',
  reviewScopeAria: 'Граница обзора — сворачивает улицы дальше (не удаляет)',
  shareProcessHu: 'Хедз-ап',
  shareProcessMultiway: 'Мультивей',
  shareReviewedLabel: 'Разбор',
  summaryCopyLabel: 'Вставить в чат — читаемо + Pro',
  summaryProLabel: 'Pro-нотация',
  emptyDash: '—',
  copyBoth: 'Поделиться в чат',
  copyHuman: 'Читаемо',
  copyPro: 'Pro-нотация',
  copied: 'Скопировано ✓',
  copiedToast: 'Резюме скопировано',
  screenshotHint: 'Захват = чистый снимок · Ссылка = открыть раздачу снова',
  captureMode: 'Захват',
  captureExit: 'Выйти из захвата',
  saveShareImage: 'Сохранить изображение',
  shareImage: 'Поделиться изображением',
  imageSaved: 'Сохранено ✓',
  imageShared: 'Отправлено ✓',
  imageSavedToast: 'Изображение сохранено',
  imageSharedToast: 'Изображение отправлено',
  imageFailedToast: 'Не удалось создать изображение',
  shareText: 'Поделиться текстом',
  shared: 'Отправлено ✓',
  copyLink: 'Копировать ссылку',
  linkCopiedToast: 'Ссылка скопирована',
  linkWithoutKnownHolesToast: 'Ссылка без карманных оппонентов (слишком длинная)',
  linkTooLongToast: 'Раздача слишком большая для ссылки',
  sharedToast: 'Отправлено',
  shareFailedToast: 'Не удалось поделиться',
  newHand: 'Новая раздача',
  receivedQuietRerecordCta: 'Записать свой процесс',
  draftRestoredHint: 'Черновик восстановлен — продолжить или начать заново?',
  draftContinue: 'Продолжить',
  actorFoldedHint: 'Уже в фолде',
  summaryHeading: '[Резюме Holecard EX]',
  summaryPlayers: (n) => `Игроки: ${n}-max`,
  summaryBlinds: (b) => `Блайнды: ${b}`,
  summaryHero: (p) => `Место: ${p}`,
  summaryStack: (s) => `Стек: ${s}`,
  summaryEff: (e) => `Eff стек: ${e} BB`,
  summaryPot: (p) => `Банк: ${p} BB`,
  summaryHoleLine: (h) => `Карман: ${h}`,
  summaryHolesHeader: 'Holes:',
  summaryKnownHoleLine: (label, cards) => `· ${label}: ${cards}`,
  summaryBoardLine: (b) => `Борд: ${b}`,
  summaryActionsHeader: '── Действия ──',
  summaryFooter: '— Сделано в Holecard EX',
  summaryProHeader: '── Pro-нотация ──',
  tableLine: (n, blinds) => `${n}-max · ${blinds}`,
  errorBlinds: 'Некорректные блайнды. BB должен быть > 0; SB ≥ 0 и ≤ BB.',
  hintFlopPartial: 'Флоп обычно из 3 карт',
  hintNoActions: 'Можно без действий — «Закончить запись» делится записью до этого места',
  missingFlopBoard: 'Есть действия флопа, но нет карт флопа',
  missingTurnBoard: 'Есть действия тёрна, но нет карты тёрна',
  missingRiverBoard: 'Есть действия ривера, но нет карты ривера',
  boardActionsMismatch: 'Действия на улице без карт борда',
  boardNeedFlop: 'Флоп пуст — добавьте карты для более ясного разбора',
  boardNeedFlopPartial: 'Дозаполните флоп',
  boardNeedTurn: 'Тёрн пуст — добавьте для более ясного разбора',
  boardNeedRiver: 'Ривер пуст — добавьте для более ясного разбора',

  softGateTitle: 'Некоторые поля ещё пусты',
  softGateBody: 'Карманные карты ещё пусты. Добавьте карманные, чтобы записать процесс, или продолжите всё равно.',
  softGateFix: "Добавить карманные",
  softGateForceConfirm: "Точно поделиться незавершённым?",
  softGateMissingHoles: (seat) => `Карманные ${seat} (2)`,
  softGateMissingActions: "Хотя бы одно действие",
  softGateBodyLead: "Ещё нужно:",
  incompleteBadge: "Незавершено",
  softGateContinue: 'Всё равно к резюме',
  softGateShare: 'Всё равно поделиться',
  softGateCopy: 'Всё равно копировать',
  softGateCancel: 'Назад',
  pickerDisabled: 'Слот не выбран',
  step: {
    setup: 'Стол',
    position: 'Место',
    cards: 'Рука',
    board: 'Борд',
    actions: 'Линия',
    summary: 'Поделиться',
  },
  street: {
    preflop: 'Префлоп',
    flop: 'Флоп',
    turn: 'Тёрн',
    river: 'Ривер',
  },
  actionType: {
    fold: 'Фолд',
    check: 'Чек',
    call: 'Колл',
    bet: 'Бет',
    raise: 'Рейз',
    allin: 'Олл-ин',
  },
  suit: {
    s: 'Пики',
    h: 'Червы',
    d: 'Бубны',
    c: 'Трефы',
  },
  positionHintMap: {
    UTG: 'Under the gun',
    "UTG+1": 'UTG+1',
    MP: 'Миддл',
    "MP+1": 'MP+1',
    HJ: 'Хайджек',
    CO: 'Кат-офф',
    BTN: 'Баттон (дилер)',
    SB: 'Малый блайнд',
    BB: 'Большой блайнд',
  },
  progressAria: (current, total, label) =>
    `Шаг ${current} из ${total}: ${label}`,
  adArea: 'Рекламный блок',
  adTop: 'Верхний рекламный блок',
  adBottom: 'Нижний рекламный блок',
  adPlaceholderHint: 'AdSense ID не задан — заглушка до деплоя',
  // Softwise M10b: memory-order input
  endHere: "Закончить здесь",
  finishRecord: "Закончить запись",
  reviewAnte: (v) => `анте ${v}`,
  reviewEffStack: (v) => `эфф. ${v}`,
  reviewBreakdownAria: 'По улицам',
  reviewPlayers: (n) => `игроков: ${n}`,
  // vocab-tags:start — screen-only poker vocabulary (review breakdown) (v1 — pending native-player review)
  reviewVocab: {
    trips: 'трипс',
    paired: 'спаренный',
    monotone: 'монотон',
    twoTone: 'двухмастный',
    rainbow: 'радуга',
    limp: 'лимп',
    open: 'опен',
    threeBet: '3-бет',
    fourBet: '4-бет',
    fiveBet: '5-бет',
    squeeze: 'сквиз',
    coldCall: 'колд-колл',
    checkRaise: 'чек-рейз',
    cBet: 'конт-бет',
    donkBet: 'донк-бет',
    probeBet: 'проб-бет',
  },
  shareSavedMark: 'Сохранено',
  // vocab-tags:end
  flowAskFlop: "Флоп · 3 карты",
  flowAskTurn: "Тёрн · 1 карта",
  flowAskRiver: "Ривер · 1 карта",
  flowWhoActs: "Ход",
  flowSizeCustom: "Своё",
  flowSizeConfirm: "OK",
  flowSizeLabel: "Размер (bb)",
  flowDone: "Линия записана",
  flowRewind: "Заново отсюда",
  flowRewindCancel: "Отмена",
  flowSeatUnrecorded: "не записано",
  flowSeatNotInvolved: "не участвует",
  flowMemoryCut: "Дальше не помню",
  lineStripAria: "Записанная линия",
  // Soft G: optional ending record (L1.5) — seat-subject, press-only, Quiet
  endingSummary: 'Концовка (необязательно)',
  endingShownLabel: 'Карты, показанные на шоудауне',
  endingPotLabel: 'Банк',
  endingCardsInput: 'Карты',
  endingMuck: 'Не показал (мак)',
  endingUnknown: 'Неизвестно',
  endingPotTo: (seat) => `${seat} забрал банк`,
  endingSplit: 'Поровну',
  endingLineLabel: 'Концовка',
  endingShownCards: (seat, cards) => `${seat} показал ${cards}`,
  endingShownMuck: (seat) => `${seat} не показал (мак)`,
  endingShownUnknown: (seat) => `${seat}: карты неизвестны`,
  endingPotSplit: 'Банк поделён',
  endingPotUnknown: 'Банк неизвестен',
  linkWithoutEndingToast: 'Ссылка длинная — концовка не включена',
  linkWithoutTakeawayToast: 'Ссылка длинная — строка процесса не включена',
  endingShownAria: (seat) => `${seat}: карты на шоудауне`,
}

export default ru
